// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3PIef","text":"SelectPayment_text__2DNxq","title":"SelectPayment_title__11iCW","btn":"SelectPayment_btn__2SZtD"};